import Vuex, { GetterTree } from 'vuex';
import { UserState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<UserState, RootState> = {
  user: (state, getters) => {
    return state.user;
  },
  userFirstName: (state, getters) => {
    return state.user?.name?.split(' ')[0];
  },
};

export default getters;
